import {Utils} from './Utils'

export interface ResponsiveConfig {
    container: HTMLElement;
    list: HTMLElement;
    dropdown: HTMLElement;
    trigger?: HTMLElement;
}

export class Responsive {
    protected overflow: number[];
    protected readonly elements: {
        container: HTMLElement;
        list: HTMLElement;
        dropdown: HTMLElement;
        trigger?: HTMLElement;
    };

    constructor({container, list, dropdown, trigger}: ResponsiveConfig) {
        this.elements = {container, list, dropdown, trigger};
        this.overflow = [];
        this.init();
    }

    public recalculate(): void {
        const {list, dropdown, trigger} = this.elements;
        if (this.noSpace()) {
            this.overflow.push(Utils.getOuterWidth(list));

            let items = [].slice.call(list.children);
            let lastChild = items.pop();
            dropdown.prepend(lastChild);

            this.toggle();
            if (trigger) trigger.classList.remove(`is-active`);
        } else {
            if (this.getAvailableSpace() > this.overflow[this.overflow.length - 1]) {
                let hidden = [].slice.call(dropdown.children);
                let firstChild = hidden.shift();
                if (firstChild) list.append(firstChild);
                this.overflow.pop();
            }

            this.toggle();
            if (trigger) trigger.classList.remove(`is-active`);
        }

        if (trigger) {
            const counter =  trigger.querySelector(`span`);
            counter.innerHTML = `<span>${dropdown.children.length}</span>`;
        }


        if (this.noSpace()) {
            this.recalculate();
        }
    }

    public noSpace(): boolean {
        let visibleWidth = Utils.getOuterWidth(this.elements.list);
        let availableWidth = (this.getAvailableSpace() < 0) ? 0 : this.getAvailableSpace();
        return (visibleWidth > availableWidth);
    }

    public getAvailableSpace(): number {
        const {container, trigger} = this.elements;
        if(trigger.classList.contains(`is-hidden`)) {
            return Utils.getInnerWidth(container);
        }
        return Utils.getInnerWidth(container) - Utils.getOuterWidth(trigger);
    }

    protected toggle(): void {
        const {dropdown, trigger} = this.elements;
        dropdown.classList.add(`is-hidden`);
        if (dropdown.children.length) {
            trigger.classList.remove(`is-hidden`);
            return;
        }
        trigger.classList.add(`is-hidden`);
    }

    protected onTriggerClick(): void {
        const {dropdown, trigger} = this.elements;
        Utils.toggleClass(dropdown, `is-hidden`);
        Utils.toggleClass(trigger, `is-active`);
    }

    public getDifference(): number {
        const {container} = this.elements;
        const elementsInContainer = container.children;
        const contentWidth = [...elementsInContainer].reduce((previousValue, child) => {
            return previousValue + Utils.getOuterWidth(child as HTMLElement);
        }, 0);

        return Utils.getInnerWidth(container) - contentWidth;
    }

    protected bindResizeEvent(): void {
        let animationFrame: number;

        window.addEventListener('resize', (evt) => {
            if (!animationFrame) {
                animationFrame = evt && requestAnimationFrame(() => {
                    animationFrame = null;
                    this.recalculate();
                });
            }
        });
    }

    protected bindTriggerEvent(): void {
        this.elements.trigger.addEventListener(`click`, () => this.onTriggerClick());
    }

    protected init(): void {
        const {container, list, dropdown, trigger} = this.elements;
        if (!container || !list || !dropdown) return;
        this.recalculate();
        this.bindResizeEvent();
        if (trigger) this.bindTriggerEvent();
    }
}